var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 7.00002H18.6V20.84C18.6 22.085 17.585 23.1 16.34 23.1H7.66C6.415 23.1 5.4 22.085 5.4 20.84V7.00002H6.6V20.84C6.6 21.425 7.075 21.9 7.66 21.9H16.345C16.93 21.9 17.405 21.425 17.405 20.84V7.00002H17.4ZM8.4 7.00002V20H9.6V7.00002H8.4ZM14.4 7.00002V20H15.6V7.00002H14.4ZM11.4 7.00002V20H12.6V7.00002H11.4ZM20 3.90002V5.10002H4V3.90002H8.4C8.4 2.24502 9.745 0.900024 11.395 0.900024H12.605C14.255 0.900024 15.6 2.24502 15.6 3.89502H20V3.90002ZM9.6 3.90002H14.4C14.4 2.90502 13.595 2.10002 12.605 2.10002H11.395C10.405 2.10002 9.6 2.90502 9.6 3.89502V3.90002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b100bb94fa301e6dccc154db88e21be9.svg";
export { ForwardRef as ReactComponent };